<template>
  <div class="container-dba">
    <!-- 公共头部 -->
    <home-header></home-header>
    <!-- banner  -->
    <div class="banner-info"></div>
    <!-- 中间内容部分 -->
    <div class="edu-wrapper">
      <div class="meun">
        <div class="meun-right">
          <p class="right-title">背景</p>
          <div class="right-wapper">
            <div class="school-text">
              北京智点数智信息技术研究院（简称智点研究院）是在全球数字经济高速发展、中国经济全面创新发展的大背景下，在国家数字经济发展“十四五”规划方案的指导下，顺应企业数字化转型浪潮应运而生。
            </div>
            <div class="school-text">
              并在此基础上智点研究院整合汇聚了国内外多位数字化领域的专家学者、企业家及相关资源。形成了面向企业的数字化基础条件的评估诊断能力以及为企业量身定制数字化转型方案的能力；拥有强大师资和高端课程资源，形成了多层次数字化人才的培训体系和能力，可以帮助企业构建高水平运营团队，提升企业的组织能力；
            </div>
            <div class="school-text">
              拥有高水平、低成本的技术平台及工具解决方案，帮助企业快速构建以数据为核心的运营平台，实现高效运营；拥有丰富的数字化转型实施经验和方案以及成功案例，可以有效辅导企业的数字化转型实施以及为企业代运营；在关键资源梳理，数据资源的汇聚、治理、应用开发等方面具有强大的能力和丰富的经验，可以有效帮助企业开发关键资源和数据资源的价值，帮助企业实现以数据为核心的智能化运营。
            </div>
          </div>
          <p class="right-title">定位、愿景</p>
          <div class="right-wapper">
            <div class="school-text">
              智点研究院重点面向产业数字化领域，初期聚焦以私域流量运营为重点的客户数字化精准运营服务，帮助TOC、TOBTOC的企业实现线上线下一体化的高效客户运营，促进企业的数字化转型和营收增长。
            </div>
            <div class="school-text">
              智点研究院的发展愿景是成为企业实施数字化转型和客户的数字化精准运营服务的首选合作伙伴；承担起为企业数智化营销赋能，推动企业数字化转型，促进企业营收增长的使命。从而服务国家经济，助力数字经济“十四五”规划落地，促进产业的转型升级。
            </div>
          </div>
          <p class="right-title">产品及服务</p>
          <div class="right-wapper">
            <div class="school-tip"><span class="c4">诊断与方案：</span>对企业数字化资源、能力，企业经营存在问题进行调研和诊断，给出针对企业所在行业、企业所处发展阶段、企业拥有资源能力等特征，提供系统性的转型实施方案，包括目标、路径、资源、团队、运营等。
            </div>
            <div class="school-tip"><span class="c4">培训与组织能力提升：</span>开展多层次人员的培训，包括面向管理团队的数字化思维提升培训，面向专业团队的专业运营培训，面向员工的数字化素养培训。
            </div>
            <div class="school-tip"><span class="c4">平台与工具服务：</span>针对企业情况为企业提供满足其业务特点，能够高效运营、低成本、灵活部署的技术平台和技术工具。
            </div>
            <div class="school-tip"><span class="c4">代运营：</span>对于企业团队人手太弱，缺少运营能力的企业，可以提供运营辅导和代运营服务。</div>
            <div class="school-tip"><span class="c4">资源和数据价值开发：</span>散帮助企业梳理各种资源，挖掘关键资源，整合、汇聚、治理数据资源，开发关键资源和数据资源的价值。通过发挥关键资源的作用给出商业模式创新的方案。发挥数据资源的核心作用实施智能化、自动化运营。
            </div>
          </div>
          <p class="right-title">运作模式</p>
          <div class="right-wapper">
            <div class="school-tip">智点研究院致力于把研究院建设成为企业数字化转型的生态平台，为此设计了以分享机制为核心的运作模式。</div>
            <div class="school-tip">一是采用开放的模式，不断扩大专家及企业；</div>
            <div class="school-tip">二是建立专家团队和企业成员的股权平台，构建良好的利益分享机制；</div>
            <div class="school-tip">三是不断为平台提供良好的资源和环境，打造成为具有丰富优质资源和高互动性、强协调性、深度共享的共创、共享的生态平台。</div>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: "EduData",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>
<style scoped>
/* .banner-info */

.banner-info {
  width: 100%;
  height: 200px;
  background: url(../../assets/images/banner002.png);
  background-size: 100% 100%;
}

.edu-wrapper {
  width: 95%;
  margin: 0 auto;
  margin-bottom: 50px;
}

.right-wapper {
  width: 100%;
}

.right-title {
  background: url(../../assets/images/pic1.png) no-repeat;
  background-size: 100% 100%;
  width: 212px;
  height: 69px;
  text-align: center;
  line-height: 56px;
  font-size: 32px;
  padding-left: 40px;
  margin-top: 25px;
  margin-bottom: 17px;
}

/*文字样式*/

.school-text {
  font-size: 29px;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
  text-indent: 50px;
  margin-top: 5px;
}

.school-tip {
  font-size: 29px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
  margin-top: 5px;
}

.school-text a {
  color: #E58111;
}

.c4 {
  font-weight: bold;
}

/* 图片样式 */

.image-wrapper {
  margin-top: 27px;
  margin-bottom: 25px;
  width: 100%;
}

.image-wrapper img {
  width: 100%;
  height: auto;
}

/* 课程样式 */

.apply {
  width: 100%;
  min-height: 190px;
  background: #e58111;
  border-radius: 5px;
  overflow: hidden;
  zoom: 1;
}

.apply ul {
  margin: 22px 44px;
}

.apply li {
  font-size: 22px;
  color: #fff;
  width: 80%;
  float: left;
  line-height: 38px;
}

.c2 {
  width: 310px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/education/hignEduPage.vue